import React from "react";
import styles from "./LoadingCircle.module.scss";

export const CardSkelten = () => {
  return (
    <div className={styles.cardskeleton}>
      <div className={styles.imageskeleton}></div>
      <div className={styles.contentskeleton}>
        <div className={styles.textskeleton}></div>
        <div className={styles.textskeleton}></div>
      </div>
    </div>
  );
};
